import React from 'react'
import Navbar from '../../Components/Navbar'
import MissionHeader from '../../Components/MissionHeader'
import OurMission from '../../Components/OurMission'
import Business from '../../Components/Business'
import Footer from '../../Components/Footer'

const Mission = () => {
  return (
    <div>
      <Navbar/>
      <MissionHeader/>
      <OurMission/>
      <Business/>
      <Footer/>
      
    </div>
  )
}

export default Mission
